import { ActivatedRoute, Route, UrlSegment } from '@angular/router';
import { isNullOrUndefined } from 'util';

export class BreadCrumb {
    readonly _label: string;
    readonly _url: string;
    readonly _empty: boolean;
    private _route: ActivatedRoute;

    public static createFromRoute(activatedRoute: ActivatedRoute, previousUrl: string, empty?: boolean) {
        const breadcrumb: BreadCrumb = new BreadCrumb(
            BreadCrumb.createLabel(activatedRoute),
            BreadCrumb.createUrl(activatedRoute, previousUrl),
            empty
        );
        breadcrumb.route = activatedRoute;
        return breadcrumb;
    }

    constructor(label: string, url: string, empty?: boolean) {
        this._label = label;
        this._url = url;
        this._route = null;
        this._empty = empty ? empty : false;
    }

    get empty() {
        return this._empty;
    }

    get route(): ActivatedRoute {
        return this._route;
    }

    set route(value: ActivatedRoute) {
        this._route = value;
    }

    get label(): string {
        return this._label;
    }

    get url(): string {
        return this._url;
    }

    private static createLabel(activatedRoute: ActivatedRoute): string {
        const routeConfig: Route = activatedRoute.routeConfig;

        if (!routeConfig) {
            return '';
        }

        const data = isNullOrUndefined(routeConfig.data) ? [] : routeConfig.data;

        if (isNullOrUndefined(data['pageTitle']) && isNullOrUndefined(data['breadCrumbTitle'])) {
            return '';
        }

        return isNullOrUndefined(data['breadCrumbTitle']) ? data['pageTitle'] : data['breadCrumbTitle'];
    }

    private static createUrl(activatedRoute: ActivatedRoute, previousUrl: string): string {
        const routeConfig: Route = activatedRoute.routeConfig;
        if (!routeConfig) {
            return '';
        }

        const url: Array<UrlSegment> = activatedRoute.snapshot.url;

        let path: string = '';
        url.forEach((_url: UrlSegment) => {
            path += _url.path + '/';
        });

        return previousUrl + path;
    }
}
